export const cookieSet = (key, value, location, days) => {
  var expires = "",
    path = "";
  if (typeof days != "undefined" && days != "") {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }
  if (typeof location != "undefined" && location != "") {
    path = "; path=" + location;
  }
  document.cookie = key + "=" + encodeURIComponent(value) + expires + path;
};

export const cookieGet = (key) => {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? decodeURIComponent(keyValue[2]) : null;
};

export const unwrap = (wrapper) => {
  // place childNodes in document fragment
  var docFrag = document.createDocumentFragment();
  while (wrapper.firstChild) {
    var child = wrapper.removeChild(wrapper.firstChild);
    docFrag.appendChild(child);
  }

  // replace wrapper with document fragment
  wrapper.parentNode.replaceChild(docFrag, wrapper);
};

export const disableScroll = () => {
  document.body.style.overflow = "hidden";
  var x = window.scrollX;
  var y = window.scrollY;
  window.scrollTo(x, y);
  window.onscroll = function () {
    window.scrollTo(x, y);
  };
};

export const enableScroll = () => {
  window.onscroll = function () {};
  document.body.style.overflow = "";
};

export const getHiddenElementHeight = (element, classToAdd) => {
  let clone = element.cloneNode(true);
  const data = element.getBoundingClientRect();
  clone.style.position = "absolute";
  clone.style.height = "auto";
  clone.style.width = data.width + "px";
  clone.classList.add(classToAdd === undefined ? "open" : classToAdd);
  clone.style.left = "-100000em";
  clone.id = "tmp-" + Math.floor(Math.random() * 99999);
  element.parentNode.appendChild(clone);
  let height = document.getElementById(clone.id).offsetHeight;
  clone.remove();
  return height;
};

export const isInViewport = (
  element,
  callback = () => {},
  threshold = { top: 0, bottom: 0 },
  showHelper
) => {
  const rect = element.getBoundingClientRect();
  if (showHelper) {
    const helper = document.createElement("div");
    helper.classList.add("helper");
    document.body.appendChild(helper);
  }
  document.addEventListener("scroll", (e) => {
    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight + threshold.bottom ||
          document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      callback(e);
    }
  });
};

export const scrollTo = (offset, callback = () => {}) => {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (Math.abs(fixedOffset - window.pageYOffset.toFixed()) < 10) {
      window.removeEventListener("scroll", onScroll);
      callback();
    }
  };

  window.addEventListener("scroll", onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
};

export const passedHTMLObject = (element) => {
  if (!element) throw new Error(`Argumentem musi być selektor lub obiekt DOM.`);

  if (typeof element === "string") {
    const domElement = document.querySelector(element);
    if (domElement) return domElement;
    throw new Error(
      `Selektor ${element} jest niepoprawny. Nie odnaleziono elementu DOM`
    );
  }

  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    if (element instanceof HTMLElement) return element;
  } catch (e) {
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have (works on IE7)
    if (
      typeof obj === "object" &&
      obj.nodeType === 1 &&
      typeof obj.style === "object" &&
      typeof obj.ownerDocument === "object"
    )
      return element;
  }
};

export const getTranslateXY = (element) => {
  const style = window.getComputedStyle(element);
  const matrix = new DOMMatrixReadOnly(style.transform);
  return {
    x: matrix.m41,
    y: matrix.m42,
  };
};

export const  wrapElement = (el, wrapper) => {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

export const createElementFromHTML = (htmlString) => {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

export const isMobile = window.innerWidth < 992;